export default "__VITE_ASSET__DbHoe9dL__"